<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container">
  <div class="card-panel mt-5 mb-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="TIPO DE FAVORECIDO" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/video-conference.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/favorecidos-tipos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()"
            class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar tipo
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="form-row">
        <div class="col-1 d-none d-lg-block d-xl-block col-md-auto"
          style="width: 45px; height: 220px; border-right: 1px solid #ebebeb; margin-right: 10px">
          <img src="assets/img/global/page_white.png" alt="">
        </div>
        <div class="col-md-11 col-lg-11 col-xl-11">
          <div class="form-row">
            <div class="form-group col-md-2">
              <label for="codigou">TCE</label>
              <input #codigo id="tce" formControlName="tce" type="text" class="form-control">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-8">
              <label for="codigou">Nome</label>
              <input #nome id="nome" formControlName="nome" type="text" class="form-control font-weight-bold">
            </div>
          </div>
          <div class="form-row">
            <div class="from-group col-md-4">
              <div class="checkbox checbox-switch switch-danger">
                <label>
                  <input type="checkbox" formControlName="obrigatorio" /><span></span>Obrigatório
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="offset-1 col-11">
          <button (click)="submitForm(true)" class="btn btn-sm btn-outline-info">
            <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
            Salvar & novo
          </button>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>
